import 'classlist.js';
import $ from 'jquery';

const $main = $( 'main' );

function makeContainerClickable( e, link ) {
	if ( link[0].href ) {
		e.preventDefault();
		if ( !e.ctrlKey && !e.metaKey ) {
			window.location = link[0].href;
		} else {
		// Open in new window/tab.
			window.open( link[0].href );
		}
	}
}

function init() {
	$main.on( 'click', '.js-previewLink', ( e ) => {
		const $link = $( e.target ).closest( '.js-previewLink' ).find( 'a' );
		makeContainerClickable( e, $link );
	} );
}

export default { init };
